module.exports = __webpack_public_path__ + "static/media/label-gray.61d4a00e.svg";